import paramsFactory from "../../utils/paramsFactory";
import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // courses
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/courses?${p}`);
  },
  show(id) {
    return api.get(`/api/admin/courses/${id}`);
  },
  create(data) {
    return api.post(`/api/admin/courses`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  update(id, data) {
    if (data instanceof FormData) {
      return api.put(`/api/admin/courses/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.put(`/api/admin/courses/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/admin/courses/${id}`);
  },
}; 